import { TripticWrapper as Wrapper } from '@components/display/Triptic'
import Map from '@components/map/Map'
import Section from '@components/display/DisplaySectionSmall'

import styles from 'styles/UserLocation.module.css'

const Location = ({ user, offer, salon }) => {
    const { location, address, dealer } = user || {}
    const { location: offerLocation, tracking } = offer || {}

    const coordinates = offerLocation?.coordinates
        || location?.coordinates

    const city = tracking?.city
        || dealer?.firm_address?.join(', ')
        || address?.full
        || address?.city

    return (
        <Wrapper>
            <Map
                coordinates={coordinates}
                height='100%' />

            <Section gray>
                { city && salon
                    ? <h2 className={styles.city}>{city}</h2>
                    : <div className={styles.city}>{city}</div> }
            </Section>
        </Wrapper>
    )
}

export default Location